import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import {
  types as actions,
  setCurrentWorkflowAction
} from '../../reducers/actions';
import { WorkflowService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_WORKFLOW),
    switchMap(action =>
      WorkflowService.get(action.workflowId, store).pipe(
        map(data => setCurrentWorkflowAction(data)),
        catchError(retryAuthentication(action$, 'epics/workflows/getWorkflow'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/workflows/getWorkflow.js